import React from "react";
import { Link } from "react-router-dom";
import Loading from "../Loading";

const Paginate = ({ data, loading, filters, searchParams, style = {} }) => {
  if (loading) {
    return (
      <div className="row justify-content-center">
        <Loading col={2} height={"20px"} count={1} />
      </div>
    );
  }
  if (data?.data?.length == 0) {
    return <></>;
  }
  const renderUrl = page => {
    let res = "?";
    filters.map(element => {
      if (searchParams.get(element.key) && element.key != "page") {
        if (res == "?") {
          res = res + `${element.key}=${searchParams.get(element.key)}`;
        } else {
          res = res + `&${element.key}=${searchParams.get(element.key)}`;
        }
      }
    });
    if (res == "?") {
      res = res + `page=${page}`;
    } else {
      res = res + `&page=${page}`;
    }
    return res;
  };
  const renderLink = link => {
    switch (link.label) {
      case "&laquo; Previous":
        return (
          <Link to={renderUrl(+data.current_page - 1)}>
            <img src={require("../../Assets/images/right.png")} />
          </Link>
        );
        break;
      case "Next &raquo;":
        return (
          <Link to={renderUrl(+data.current_page + 1)}>
            <img src={require("../../Assets/images/left.png")} />
          </Link>
        );
      case "...":
        return <Link to={renderUrl(+data.current_page)}> ... </Link>;
      default:
        return (
          <Link
            to={renderUrl(+link.label)}
            className={+data.current_page === +link.label && "active"}
          >
            {link.label}
          </Link>
        );
        break;
    }
  };
  return (
    <>
      <div className="row justify-content-center">
        <div className="col-5  d-flex justify-content-center">
          <div className="paginate" style={{ ...style }}>
            {data.links.map(link => {
              return renderLink(link);
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Paginate;
